// extracted by mini-css-extract-plugin
module.exports = {"split":"Split_split__wOy_G"};